import { ProductType } from '@/shared/enums';
import { sortBookmarks } from '@/shared/utils';

export default (bookmarks = []) => {
  const episodeFilter = ({ type, season }) => type === ProductType.EPISODE && season;
  const notEpisodeFilter = ({ type, bookmark }) => type !== ProductType.EPISODE && !bookmark?.watched;

  const episodes = bookmarks.filter(episodeFilter);
  const notEpisodes = bookmarks.filter(notEpisodeFilter);
  const lastEpisodes = getLastBookmarkedEpisodesGroupedBySerials(episodes);

  return ([...lastEpisodes, ...notEpisodes]);
};

const getLastBookmarkedEpisodesGroupedBySerials = (episodes) => {
  const uniqueSerialsIds = [...new Set(episodes.map(({ season }) => season.serial.id))];
  return uniqueSerialsIds.map(
    (serialId) => sortBookmarks(
      episodes.filter(({ season }) => season.serial.id === serialId),
    )[0],
  );
};
